"use strict";

export function initInScope ($scope) {

    /* preisberechnung umgebaut auf ajaxform */

    if ((window.matchMedia('(max-width: 991px)').matches)) {
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 650) {
                $('.js-objekt-detail-sticky').addClass('is-visible');
                $('footer').css('padding-bottom','6rem');
            } else {
                $('.js-objekt-detail-sticky').removeClass('is-visible');
            }
        });
    }




    /* fehlermeldung wenn keine personen (kundewunsch!!!) */
    $scope.find('.js-objekt-detail-submit-form').on('submit',function (e) {
        if(_config.objectDetailPersonsSelected){

        } else {
            e.preventDefault();
            $('.js-object-detail-persons-error').attr('hidden',false);

            /* mobile sticky button */
            if ((window.matchMedia('(max-width: 767px)').matches)) {
                $('html, body').animate({
                    scrollTop: $('.js-sticky-box').offset().top - 120
                }, 1000);
            }
        }
    });

    if(_config.objectDetailPersonsSelected){
        $('.js-object-detail-persons-error').attr('hidden','hidden')
    }



    /* expose link */
    $scope.find('.js-expose-values').on('click',function (e) {
        e.preventDefault();

        let href = $(this).attr('href');
        let persons = $('.js-expose-input__persons').val();
        let from = $('.js-expose-input__from').val();
        let to = $('.js-expose-input__to').val();


        window.open(href+'?persons='+persons+'&from='+from+'&to='+to, '_blank');
    });


}